<template>
    <div class="wz_map">
        <!-- 网站地图 -->
        <div class="content">
            <div class="infoCon inner">
                <!-- 面包屑导航 -->
                <div class="mbnav">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">
                            <img class="homeIcon" src="/statics/image/index/home.png" alt />
                            首页
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>网站地图</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <!-- 地图 -->
                <div class="mapCon">
                    <h3 @click="toPage(-1, -1)">网站首页</h3>
                    <div v-for="(item, index) in catelist" :key="index">
                        <div class="wz_nav" v-if="item.display">
                            <h3>
                                <a :href="item.url" v-if="item.display && item.link_flag == 1"
                                    target="_blank">{{ item.title }}</a>
                                <span class="title" @click="toPage(item.id, index)"
                                    v-if="item.display && item.link_flag == 0">{{ item.title }}</span>
                            </h3>
                            <div v-if="item.display && item.s_cates && item.link_flag == 0">
                                <span v-for="(itema, indexa) in item.s_cates" :key="indexa"
                                    @click="toDaoh(item.id, index, itema.id)"><span class="title"
                                        v-if="itema.display">{{ itema.title }}</span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            catelist: []
        };
    },
    created() {
        this.getNav();
    },
    // components: {
    //   indexTop,
    //   indexFooter
    // },
    methods: {
        toPath(url, obj) {
            if (this.$route.fullPath == url) {
                return;
            }
            if (this.$route.path == url) {
                this.$router.push({
                    path: url,
                    query: obj
                });
                return;
            }
            this.$router.push({
                path: url,
                query: obj
            });
        },
        toPage(id, index) {
            // this.nowId = id;
            // this.nowindex = index;
            // console.log("top", this.nowindex);
            console.log('to page',id)
            console.log('to page',index)
            if (id == 5463) {
                this.toPath("/leaderInfo", { index: index });
            } else if (id == 5473) {
                this.toPath("/interaction", { index: index });
            } else if (id == 29) {
                this.toPath("/ztzl", { index: index });
            } else if (id == -1) {
                this.toPath("/", {});
            } else {
                this.toPath("/xqNews", { id: id, index: index });
            }
        },
        toDaoh(id, index, dhid) {
            console.log('to daohang')
            if (id == 5463) {
                this.toPath("/leaderInfo", { index: index, dhid: dhid });
            } else if (id == 5473) {
                this.toPath("/interaction", { index: index });
            } else {
                this.toPath("/xqNews", { id: id, index: index, dhid: dhid });
            }
        },
        getNav() {
            var that = this;
            that.$api.index.catelist({'type':1}).then(function (res) {
                if (res.code == 200) {
                    that.catelist = res.result.all_cate;
                }
            });
        }
    }
};
</script>

<style></style>